export enum View2dType {
  rooms = 'app.rooms',
  area = 'app.area',
  numeration = 'app.numeration',
  price = 'app.price',
  priceAlternative = 'app.priceAlternative',
  pricePM = 'app.pricePM',
  pricePMAlternative = 'app.pricePMAlternative',
  row0 = 'app.row0',
  row1 = 'app.row1',
  row2 = 'app.row2',
  row3 = 'app.row3',
  row4 = 'app.row4',
  row5 = 'app.row5',
  row6 = 'app.row6',
  row7 = 'app.row7',
  row8 = 'app.row8',
  row9 = 'app.row9',
}
